// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td a:link,td a:visited{color:#606266}.tooltip{max-width:400px}", ""]);
// Exports
module.exports = exports;
